[
  {
    "region": "Canada",
    "code": "+1",
    "regionAbbr": "CA"
  },
  {
    "region": "United States",
    "code": "+1",
    "regionAbbr": "US"
  }
]